"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshNotificationRenderer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const LinkButton_1 = require("../../controls/LinkButton");
const helpers_1 = require("../cellRenderers/helpers");
const helpers_2 = require("../../helpers");
const Icon_1 = require("../../Icon");
const icons_1 = require("../../icons");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
const Tooltip_1 = require("../../Tooltip");
const View_1 = require("../../View");
const svg_1 = require("../svg");
const TitleWithTooltipWrapper = styled_components_1.default.div `
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: ${helpers_2.SPACING_M};

    ${Text_1.Text.selector} {
        margin-left: ${helpers_2.SPACING_S};
    }
`;
const TitleWithTooltip = (_a) => {
    var { text } = _a, rest = __rest(_a, ["text"]);
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, text),
        render: (tooltipProps) => {
            return (react_1.default.createElement(TitleWithTooltipWrapper, Object.assign({}, rest, { onMouseEnter: () => {
                    (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref)();
                }, onMouseLeave: () => {
                    tooltipProps.onMouseLeave();
                }, ref: ref }),
                react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.LargeInfoStatusIcon, null) }),
                react_1.default.createElement(Text_1.Text, { truncate: true }, text)));
        }
    });
};
const RefreshWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    overflow: hidden;
`;
const refreshNotificationRenderer = ({ text = 'The data set has been changed.', refreshTextButton = 'Refresh', ignoreTextButton = 'Ignore', onRefresh = () => { }, onIgnore = () => { } } = {}) => {
    return (react_1.default.createElement(RefreshWrapper, { spaceFill: View_1.SPACE_FILL.all, gap: StackView_1.STACK_GAP.l },
        react_1.default.createElement(TitleWithTooltip, { "data-selector-id": "refresh-notification-text", text: text }),
        react_1.default.createElement(LinkButton_1.LinkButton, { "data-selector-id": "refresh-link", compact: true, iconBefore: react_1.default.createElement(svg_1.Refresh, null), onClick: (e) => {
                e.preventDefault();
                onRefresh();
            } }, refreshTextButton),
        react_1.default.createElement(LinkButton_1.LinkButton, { "data-selector-id": "ignore-link", compact: true, iconBefore: react_1.default.createElement(svg_1.Ignore, null), onClick: (e) => {
                e.preventDefault();
                onIgnore();
            } }, ignoreTextButton)));
};
exports.refreshNotificationRenderer = refreshNotificationRenderer;
//# sourceMappingURL=refreshNotificationRenderer.js.map